import { api } from './api'

export interface ConsentStatus {
  dataProcessingConsent: boolean
  consentVersion?: string
  consentGivenAt?: string
}

export interface AcceptConsentRequest {
  consentVersion: string
}

export interface AcceptConsentResponse {
  dataProcessingConsent: boolean
  consentVersion: string
  consentGivenAt: string
}

/**
 * Get current user's consent status
 * GET /api/users/me/consent
 */
export async function getConsentStatus(): Promise<ConsentStatus> {
  const response = await api.get<ConsentStatus>('/users/me/consent')
  return response.data
}

/**
 * Accept data processing consent
 * POST /api/users/me/consent
 */
export async function acceptConsent(
  consentVersion: string = '1.0'
): Promise<AcceptConsentResponse> {
  const response = await api.post<AcceptConsentResponse>('/users/me/consent', {
    consentVersion,
  })
  return response.data
}
